import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { DuckDBProvider } from './context/DuckDBContext';
import Home from './pages/Home';
import CompanyLogin from './pages/CompanyLogin';
import ChatPage from './pages/ChatPage';
import Prompts from './pages/Prompts';

const SavedQueriesPage = React.lazy(() => import('./pages/SavedQueriesPage'));

function App() {
  return (
    <AuthProvider>
      <DuckDBProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/prompts" element={<Prompts />} />
            <Route path="/:company" element={<CompanyLogin />} />
            <Route path="/:company/dashboard" element={<ChatPage />} />
            <Route
              path="/joinpavilion/source-of-truth-data"
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <SavedQueriesPage />
                </Suspense>
              }
            />
          </Routes>
        </BrowserRouter>
      </DuckDBProvider>
    </AuthProvider>
  );
}

export default App;
